import styled from 'styled-components';
import BackgroundImage from 'assets/svg/bg_login_portal_client_grey.svg';
import { h6Styles } from 'utils/resuable-css';

export const BgLogin = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  width: 100%;
  padding: 18px 20px;
  min-height: 100vh;
  @media only screen and (max-width: 1440px) {
    padding: 15px;
  }
`;
export const TopWindows = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
`;
export const BottomWindows = styled.div`
  display: flex;
  margin-top: 12px;
  width: 100%;
  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
`;
export const TicketNotFound = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  font-weight: bold;
  text-align: center;
  width: 100%;
  padding: 2em 0;
`;
